// src/components/AccessDeniedPage.tsx

import React, { useEffect } from "react";
import { Container, Typography, Button, Box } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { UsuarioEstaLogado } from "../../utils/usuarioEstaLogado";
import configUrls from "../../config/configUrls";

export const ForbiddenPage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    console.warn("Usuário foi redirecionado para /403 - acesso negado");

    const usuario = UsuarioEstaLogado();
    if (!usuario) {
      // Se não estiver logado, envia para a página de login ou home
      navigate(configUrls.SITE_LOGIN); // ou configUrls.SITE_HOME
    }
  }, [navigate]);

  const handleGoBack = () => {
    navigate(configUrls.SITE_HOME);
  };

  return (
    <Container maxWidth="sm" style={{ textAlign: "center", marginTop: "50px" }}>
        
      <Box
        bgcolor="error.main"
        color="error.contrastText"
        p={4}
        borderRadius={4}
        boxShadow={3}
      >
        <Typography
          variant="h3"
          component="h1"
          gutterBottom
          role="alert"
          aria-live="assertive"
        >
          403 - Acesso negado
        </Typography>

        <Typography variant="h6" component="p" gutterBottom>
          Você não tem permissão para acessar esta funcionalidade.
        </Typography>

        <Button
          variant="contained"
          color="primary"
          onClick={handleGoBack}
          style={{ marginTop: "20px" }}
        >
          Voltar para a Página Inicial
        </Button>
      </Box>
    </Container>
  );
};
